import { isRudderUser } from '@components/common/util/util';
import { disableCognito, featureAudiences } from '@config';
import { stores } from '@stores/index';

export enum Feature {
  teams = 'teams',
  grafana = 'grafana',
  auditLogs = 'auditLogs',
  zendesk = 'zendesk',
  enforceMfa = 'enforceMfa',
  billingSettings = 'billingSettings',
  usageSettings = 'usageSettings',
  securitySettings = 'securitySettings',
  enableMFA = 'enableMFA',
  personalAccessTokenSetttings = 'personalAccessTokenSetttings',
  companySettings = 'companySettings',
  isSetupTabEnabled = 'isSetupTabEnabled',
  models = 'models',
  cronScheduling = 'cronScheduling',
  trackingPlans = 'trackingPlans',
  warehouseConfigurationTesting = 'warehouseConfigurationTesting',
  quickstart = 'quickstart',
  whtProjects = 'whtProjects',
  permissions = 'permissions',
  audiences = 'audiences',
  enableNewSettings = 'enableNewSettings',
}

export default () => {
  const { workspaceStore, billingStore, userStore, organizationStore } = stores;
  const features = {
    [Feature.teams]: workspaceStore.enableTeams && !organizationStore.isOpenSource,
    [Feature.grafana]: workspaceStore.enableGrafana,
    [Feature.auditLogs]: userStore.isAdmin && organizationStore.isEnterprise,
    [Feature.zendesk]: organizationStore.isPro || organizationStore.isEnterprise,
    [Feature.enforceMfa]:
      (organizationStore.isEnterprise || organizationStore.isPro) && userStore.isTeamsAdmin,
    [Feature.billingSettings]: billingStore.isShowBilling,
    [Feature.usageSettings]: billingStore.isShowUsagePage,
    [Feature.securitySettings]: !userStore.isOpenSource && !disableCognito,
    [Feature.enableMFA]: !userStore.isOpenSource && !disableCognito,
    [Feature.personalAccessTokenSetttings]: !organizationStore.isOpenSource,
    [Feature.companySettings]: userStore.isAdmin,
    [Feature.audiences]: featureAudiences,
    [Feature.models]: !userStore.isOpenSource,
    [Feature.cronScheduling]: true,
    [Feature.trackingPlans]: workspaceStore.enableTrackingPlansUI,
    [Feature.warehouseConfigurationTesting]:
      organizationStore.isFreeTrial || organizationStore.isPro,
    [Feature.permissions]: workspaceStore.enablePermissions && userStore.isTeamsAdmin,
    [Feature.quickstart]: organizationStore.isOpenSource || organizationStore.isFreeTrial,
    // TODO: Enable whtProjects based on business rules from config backend.
    // Not sure about source of flag [organizationStore.?]
    [Feature.whtProjects]: process.env.REACT_APP_ENV === 'dev',
    [Feature.enableNewSettings]: true,
    [Feature.isSetupTabEnabled]: isRudderUser(userStore.email),
  };

  const isEnabled = (e: Feature) => features[e];
  return isEnabled;
};
